import { gql } from 'graphql-request';

export const TASK_CATEGORY_FIELDS = gql`
  fragment TaskCategoryFields on TaskCategoryDto {
    taskCategoryId
    name
    color
    isActive
    sortOrder
    isGlobal
    organizationId
    createdAt
  }
`;

export const getTaskCategories = gql`
  query getTaskCategories {
    getTaskCategories {
      ...TaskCategoryFields
    }
  }
  ${TASK_CATEGORY_FIELDS}
`;

export const getActiveTaskCategories = gql`
  query getActiveTaskCategories {
    getActiveTaskCategories {
      ...TaskCategoryFields
    }
  }
  ${TASK_CATEGORY_FIELDS}
`;

export const createTaskCategory = gql`
  mutation createTaskCategory($taskCategory: TaskCategoryCreateInput!) {
    createTaskCategory(taskCategory: $taskCategory) {
      ...TaskCategoryFields
    }
  }
  ${TASK_CATEGORY_FIELDS}
`;

export const updateTaskCategory = gql`
  mutation updateTaskCategory($taskCategory: TaskCategoryUpdateInput!) {
    updateTaskCategory(taskCategory: $taskCategory) {
      ...TaskCategoryFields
    }
  }
  ${TASK_CATEGORY_FIELDS}
`;

export const deleteTaskCategory = gql`
  mutation deleteTaskCategory($taskCategoryId: String!) {
    deleteTaskCategory(taskCategoryId: $taskCategoryId) {
      affected
    }
  }
`;

const TaskCategoryGraphQL = {
  fragments: {
    TASK_CATEGORY_FIELDS,
  },
  queries: {
    getTaskCategories,
    getActiveTaskCategories,
  },
  mutations: {
    createTaskCategory,
    updateTaskCategory,
    deleteTaskCategory,
  },
};

export default TaskCategoryGraphQL;
